import React, { useState, useContext } from "react";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from '@mui/material/Tooltip';
import moment from "moment/moment";
import { useHistory } from 'react-router-dom';


import { formatDoctorSlots } from "./timeRanges";
import { transformDoctorSlots } from "../Helper/utils";
import { logEventToAnalyticsPlatform } from "../../../helper/events"
import { EVENTS } from "../events_Constant"
import { unselectedStyle, selectedStyle } from "../StyledComponent"
import { getUrlForDoctorSchedulePage } from "../Helper/utils"
import { SLOTS_DAY_CONSTANT } from "../constant";
import UserFeaturesContext from "../../../hook/UserDetails/UserFeaturesContext";
import { checkFeatureFeasbility } from "../../../helper/utils";
import { FEATURE_NAME } from "../constant";

export const SlotsDayView = ({ doctorSlots, doctorId, providerId }) => {
  const newDoctorSlots = transformDoctorSlots(doctorSlots);
  const history = useHistory();
  const { userFeatures } = useContext(UserFeaturesContext);


  let availableDayIndices = [];
  if (newDoctorSlots) {
    availableDayIndices = Object.entries(newDoctorSlots.DoctorSlots)
      .filter(([day, details]) => details.isSlotsAvailable)
      .map(([day]) => {
        return parseInt(day)
      });
  }

  const handleClickOpen = (drId) => {
    logEventToAnalyticsPlatform({
      name: EVENTS.PC_LS_ACTION.name,
      payload: {
        tab_name: EVENTS.TAB_NAME_LC_SCREEN,
        filterValue: '',
        reference_id: "" + drId,
        reference_provider_id: "" + providerId,
        service_name: EVENTS.SERVICE_NAME_OFFLINE_CONSULTS,
        action: EVENTS.ACTION.EDIT_SLOTS_ICON,
      },
      schema: EVENTS.PC_LS_ACTION.schema,
    })
    const url = getUrlForDoctorSchedulePage(drId);
    history.push(url);
  };

  const schedule = formatDoctorSlots(newDoctorSlots);

  return (
    <>
      <div className="flex justify-between">
        <div className="flex gap-1">
          {SLOTS_DAY_CONSTANT.map((day, index) => (
            <Tooltip
              title={
                <React.Fragment>
                  {Object.entries(schedule).filter(([days, details]) =>
                    days == day.index).map(([days, times]) =>
                    (<div key={days}>
                      {times?.length > 0 ? (
                        times?.map((time, index) => (
                          <p className=' text-normal font-normal'>
                            {time}
                          </p>
                        ))
                      ) : (
                        <p className=' text-normal font-normal'>
                          No slots available</p>
                      )}
                    </div>
                    ))}
                </React.Fragment>

              }
            >
              <div key={day.key}
                className="flex items-center justify-center text-[#A4B0C0] rounded-full border border-[#A4B0C0] text-[0.75rem] "
                value={index}
                aria-label={day.key}
                style={availableDayIndices.includes(index) ? selectedStyle : unselectedStyle}
              >
                {day.label}
              </div>
            </Tooltip>
          ))}


        </div>
        {checkFeatureFeasbility(FEATURE_NAME.UPDATE_DOCTOR, userFeatures) && <img src="https://views.medibuddy.in/providerUi/assets/editIcon.svg" alt="Edit" onClick={(e) => { handleClickOpen(doctorId) }} style={{ cursor: 'pointer' }} />}

      </div>

    </>
  );
};

export default SlotsDayView;
